var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: { "tile is-parent": _vm.isTiled } }, [
    _c(
      "article",
      { class: { "tile is-child box": _vm.isTiled } },
      [
        _c("div", { staticClass: "columns is-gapless" }, [
          _c("div", { staticClass: "column" }, [
            _vm.isTiled
              ? _c("p", { staticClass: "title" }, [_vm._v("Addresses")])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "column is-narrow" }, [
            _c(
              "div",
              {
                staticClass: "dropdown is-right",
                class: { "is-active": _vm.dropdownActive },
                on: {
                  mouseleave: function ($event) {
                    _vm.dropdownActive = false
                  },
                },
              },
              [
                _c("div", { staticClass: "dropdown-trigger" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: {
                        "aria-haspopup": "true",
                        "aria-controls": "dropdown-menu dropdown-item-has-icon",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toogleDropdown()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "icon is-small is-left" }, [
                        _c("i", {
                          staticClass: "mdi mdi-18px",
                          class: [
                            _vm.selectedMapSource == "Google"
                              ? "mdi-google-maps"
                              : "mdi-map-marker-radius",
                          ],
                        }),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.selectedMapSource))]),
                      _vm._m(0),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "dropdown-menu", attrs: { role: "menu" } },
                  [
                    _c("div", { staticClass: "dropdown-content" }, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item dropdown-item-has-icon",
                          class: {
                            "is-active": _vm.mapSource === "AddressListGoogle",
                          },
                          attrs: { href: "#", id: "AddressListGoogle" },
                          on: {
                            click: function ($event) {
                              return _vm.selectMapSource($event)
                            },
                          },
                        },
                        [
                          _vm._m(1),
                          _c("span", { staticClass: "dropdown-item-text" }, [
                            _vm._v("Google"),
                          ]),
                        ]
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item dropdown-item-has-icon",
                          class: {
                            "is-active": _vm.mapSource === "AddressListMapbox",
                          },
                          attrs: { href: "#", id: "AddressListMapbox" },
                          on: {
                            click: function ($event) {
                              return _vm.selectMapSource($event)
                            },
                          },
                        },
                        [
                          _vm._m(2),
                          _c("span", { staticClass: "dropdown-item-text" }, [
                            _vm._v("Mapbox"),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _c(_vm.mapSource, {
          tag: "component",
          attrs: {
            addresses: _vm.addresses,
            "is-tiled": _vm.isTiled,
            v: _vm.v,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", {
        staticClass: "mdi mdi-chevron-down",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small is-left" }, [
      _c("i", { staticClass: "mdi mdi-google-maps mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small is-left" }, [
      _c("i", { staticClass: "mdi mdi-map-marker-radius mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }